export default __webpack_public_path__ + "static/media/Explorer_Logo.bb790231.png";